import { Box } from '@bechtel/gds';
import styled from 'styled-components';
export const DocumentSectionStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
  flexGrow: { sm: 1 },
})`
  background-color: ${({ theme }) => theme.colors.grey[100]};
`;

export const DocumentViewStyled = styled.div`
  height: 244px;
  width: 100%;
  overflow: hidden;
  padding: ${({ theme }) => theme.spacings[100]};
  & * canvas {
    margin: auto;
    width: 100% !important;
    height: 240px !important;
  }

  &:first-child {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
`;
